import React from 'react';

interface IRentReportCheckIcon {
  color?: string;
  onClick?: any;
}
const RentReportCheckIcon = ({ color, onClick }: IRentReportCheckIcon) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    onClick={onClick}
    style={{ cursor: 'pointer' }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.0001 13.3996C10.5347 13.3996 13.4001 10.5342 13.4001 6.99961C13.4001 3.46499 10.5347 0.599609 7.0001 0.599609C3.46548 0.599609 0.600098 3.46499 0.600098 6.99961C0.600098 10.5342 3.46548 13.3996 7.0001 13.3996ZM9.96578 5.96529C10.2782 5.65288 10.2782 5.14634 9.96578 4.83392C9.65336 4.5215 9.14683 4.5215 8.83441 4.83392L6.2001 7.46824L5.16578 6.43392C4.85336 6.1215 4.34683 6.1215 4.03441 6.43392C3.72199 6.74634 3.72199 7.25287 4.03441 7.56529L5.63441 9.16529C5.94683 9.47771 6.45336 9.47771 6.76578 9.16529L9.96578 5.96529Z"
      fill={color || '#027A48'}
    />
  </svg>
);
export default RentReportCheckIcon;
